import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createSelector, createStructuredSelector } from 'reselect';
import { isCartBoxBuilderPopupShownSelector, isPreventUnsavedBoxBuilderProgressPopupShownSelector, isBoxBuilderSelectProductsDrawerShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { BOX_BUILDER_SELECT_PRODUCTS_DRAWER, CART_BOX_BUILDER_POPUP } from 'swag-client-common/constants';
import { currentStepSelector, editingBoxTypeBoxIdSelector, hasUnsavedChangesSelector, isEditModeSelector } from '../../../redux/box-builder/box-builder.selectors';
import { resetBoxBuilderState, setEditingBoxTypeBoxId } from '../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../redux/box-builder/box-builder.constants';
import { PreventUnsavedBoxBuilderProgressPopupComponent } from './prevent-unsaved-box-builder-progress-popup';
const shouldPreventOnLocationChangeSelector = createSelector(hasUnsavedChangesSelector, isCartBoxBuilderPopupShownSelector, isPreventUnsavedBoxBuilderProgressPopupShownSelector, isBoxBuilderSelectProductsDrawerShownSelector, (hasUnsavedChanges, isBoxBuilderPopupShown, isPreventUnsavedBoxBuilderProgressPopupShown, isBoxBuilderSelectProductsDrawerShownSelector) => {
  return hasUnsavedChanges && (isBoxBuilderPopupShown || isPreventUnsavedBoxBuilderProgressPopupShown || isBoxBuilderSelectProductsDrawerShownSelector);
});
const popupTitleSelector = createSelector(isEditModeSelector, isEditMode => {
  return `Hey, are you sure you want to cancel ${isEditMode ? 'editing' : 'building'} a box?`;
});
const continueTextSelector = createSelector(isEditModeSelector, isEditMode => {
  return `Continue ${isEditMode ? 'editing' : 'building'} a box`;
});
const mapStateToProps = createStructuredSelector({
  id: editingBoxTypeBoxIdSelector,
  open: isPreventUnsavedBoxBuilderProgressPopupShownSelector,
  onCancelPopupShown: createSelector(currentStepSelector, currentStep => {
    if ([STEPS.SELECT_ADDONS_FOR_BOX, STEPS.SELECT_PRODUCTS_FOR_BOX].includes(currentStep)) {
      return BOX_BUILDER_SELECT_PRODUCTS_DRAWER;
    }
    return CART_BOX_BUILDER_POPUP;
  }),
  shouldPreventOnLocationChange: shouldPreventOnLocationChangeSelector,
  title: popupTitleSelector,
  continueText: continueTextSelector
});
const mapDispatchToProps = dispatch => ({
  handleConfirm: () => {
    dispatch(resetBoxBuilderState());
    dispatch(hidePopup());
  },
  handleCancel: (onCancelPopupShown, id) => {
    dispatch(hidePopup({
      shouldControlScroll: false
    }));
    setTimeout(() => {
      if (id) {
        dispatch(setEditingBoxTypeBoxId(id));
      }
      dispatch(showPopup({
        popup: onCancelPopupShown
      }));
    }, 250);
  }
});
export const PreventUnsavedBoxBuilderProgressPopup = withRouter(connect(mapStateToProps, mapDispatchToProps)(PreventUnsavedBoxBuilderProgressPopupComponent));